import { Component, Input } from '@angular/core';
import { Constants } from '@shared/constants/constants';

@Component({
  selector: 'dp-status-badge',
  template: '<span class="badge {{badgeClass}}">{{status}}</span>'   // rounded-pill, badge-soft-warning
})
export class DpStatusBadgeComponent {

  badgeClass: string;
  private readonly dangerStatus = [
    Constants.gcicStatus.NO_COVERAGE.code,
    Constants.gcicStatus.PENDING.code,
    Constants.gcicStatus.ASC_DECLINED.code,
    Constants.gcicStatus.SR_CANCEL.code,
  ];

  private readonly primaryStatus = [
    Constants.gcicStatus.ASSIGNED.code,
    Constants.gcicStatus.ACKNOWLEDGE.code,
    Constants.gcicStatus.PRODUCT_RECEIVED.code,
    Constants.gcicStatus.ENGINEER_ASSIGNED.code,
    Constants.gcicStatus.SR_COMPLETE.code,
  ];

  private readonly warningStatus = [
    'new'
  ];

  constructor() {
  }

  private _status: string;

  get status(): string {
    return this._status;
  }

  @Input()
  set status(status: string) {
    if (!status) {
      return;
    }

    let badgeClass;

    if (this.dangerStatus.indexOf(status) >= 0) {
      badgeClass = 'bg-danger';
    } else if (this.primaryStatus.indexOf(status) >= 0) {
      badgeClass = 'bg-primary';
    } else if (this.warningStatus.indexOf(status) >= 0) {
      badgeClass = 'bg-warning';
    } else {
      badgeClass = 'bg-secondary';
    }

    this.badgeClass = badgeClass;
    this._status = status;
  }
}
